import { IBuildingSchema } from '../../../../../repositories/monolith-python/entities/offer/BuildingSchema';
import { ICranageTypeSchema } from '../../../../../repositories/monolith-python/entities/offer/CranageTypeSchema';
import { ILiftTypeSchema } from '../../../../../repositories/monolith-python/entities/offer/LiftTypeSchema';
import { IOfferState } from '../../../../reducers';

export const mapBuilding = (offer: IOfferState): IBuildingSchema | null => {
  const { building } = offer;

  if (!building) {
    return null;
  }

  let {
    cargoLiftsCount,
    passengerLiftsCount,
    liftTypes,
    cranageTypes,
    ...restBuilding // eslint-disable-line prefer-const
  } = building;

  if (cargoLiftsCount === 0) {
    cargoLiftsCount = null;
  }

  if (passengerLiftsCount === 0) {
    passengerLiftsCount = null;
  }

  if (liftTypes) {
    liftTypes = liftTypes.filter(({ count }) => !!count);
  }

  if (cranageTypes) {
    cranageTypes = cranageTypes.filter(({ count }) => !!count);
  }

  return {
    ...restBuilding,
    cargoLiftsCount,
    passengerLiftsCount,
    liftTypes: liftTypes as unknown as Array<ILiftTypeSchema>,
    cranageTypes: cranageTypes as unknown as Array<ICranageTypeSchema>,
  };
};
